import { ReactNode } from "react";
import { Provider as StoreProvider } from "react-redux";
import store from "@/store";
import { ConfigProvider as AntdProvider } from "antd";
import zhCN from "antd/locale/zh_CN";
import enUS from "antd/locale/en_US";
import { StyleProvider, legacyLogicalPropertiesTransformer } from "@ant-design/cssinjs";
import { MessageProvider, ModalProvider } from "@/utils/antdUtils";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import "dayjs/locale/en";
import duration from "dayjs/plugin/duration";
import ErrorBoundary from "@/components/ErrorBoundary";
import LocaleProvider from "@/components/LocaleProvider";
import "@/i18n"; // 导入 i18n 配置
import process from "process";

dayjs.extend(duration);

if (typeof window !== "undefined" && process.env.NODE_ENV === "development") {
  const { pathname, search, hash } = window.location;
  if (!hash && pathname !== "/" && !pathname.includes(".")) {
    window.location.replace(`${window.location.origin}/#${pathname}${search}`);
  }
}

export function rootContainer(container: ReactNode) {
  return (
    <ErrorBoundary>
      {/*兼容360浏览器*/}
      <StyleProvider transformers={[legacyLogicalPropertiesTransformer]} hashPriority="high">
        {/* 动态语言配置 */}
        <LocaleProvider>
          {/* message获取context */}
          <MessageProvider>
            {/* modal获取context */}
            <ModalProvider>
              {/* store状态管理 */}
              <StoreProvider store={store}>{container}</StoreProvider>
            </ModalProvider>
          </MessageProvider>
        </LocaleProvider>
      </StyleProvider>
    </ErrorBoundary>
  );
}
